import Vue from 'vue'
import Router from 'vue-router'
import { BasicLayout,H5Layout } from '@/layouts';

import Index from '@/pages/index/index'

import menu1 from '@/pages/carbonMenu1/index'  //碳标签 标准制定
import menu1_1 from '@/pages/carbonMenu1/menu1_1'  //碳标签 标准制定
import menu1_2 from '@/pages/carbonMenu1/menu1_2'  //碳标签 标准制定

import menu2_1 from '@/pages/carbonMenu1/menu2_1'  //碳标签 标准制定
import menu2_2 from '@/pages/carbonMenu1/menu2_2'  //碳标签 标准制定
import menu2_3 from '@/pages/carbonMenu1/menu2_3'  //碳标签 标准制定

import menu3060_1 from '@/pages/carbonMenu1/menu3060_1'  //碳标签 标准制定
import menu3060_2 from '@/pages/carbonMenu1/menu3060_2'  //碳标签 标准制定
import menu3060_3 from '@/pages/carbonMenu1/menu3060_3'  //碳标签 标准制定

import menu4 from '@/pages/carbonMenu1/menu4'  //碳标签 标准制定

import articleDetail from '@/pages/articleDetail/index'  //碳标签 标准制定
import resources from '@/pages/resources/resources'  //碳标签 标准制定
import aboutUs from '@/pages/AboutUs/AboutUs'  //碳标签 标准制定
import bigScreenMap from "@/pages/bigScreenMap/bigScreenMap";

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes:[
        {
            path: '/',
            component: BasicLayout,
            redirect: '/index',
            title:'首页',
            meta:{title:'首页'},
            children: [
                {
                    meta:{title:'首页'},
                    path: '/index',
                    name: 'index',
                    component: Index,
                },
                {
                    path: '/biaoqian',
                    component:  { render: h => h('router-view') },
                    name: 'biaoqian',
                    meta:{title:'碳标签'},
                    redirect: '/biaoqian/menu1',
                    children: [
                        {
                            path: 'menu1',
                            name: 'menu1',
                            meta:{title:'碳标签'},
                            component:menu1,
                        },
                        {
                            path: 'menu1_1',
                            name: 'menu1_1',
                            meta:{title:'低碳产品声明'},
                            component:menu1_1,
                        },
                        {
                            path: 'menu1_2',
                            name: 'menu1_2',
                            meta:{title:'碳标签声明报告'},
                            component:menu1_2,
                        },
                        {path: 'articleDetail', meta:{title:'文字详情'}, name: 'articleDetail', component:articleDetail }
                    ]
                },
                {
                    path: '/shangchu',
                    component: { render: h => h('router-view') },
                    name: 'shangchu',
                    meta:{title:'商厨类碳标签'},
                    redirect: '/shangchu/menu2_1',
                    children: [
                        {path: 'menu2_1', name: 'menu2_1',meta:{title:'商厨类碳标签评价'}, component:menu2_1},
                        {path: 'menu2_2', name: 'menu2_2',meta:{title:'商厨类产品供应商声明报告'}, component:menu2_2},
                        {path: 'menu2_3', name: 'menu2_3',meta:{title:'双枪商厨新闻'}, component:menu2_3},
                        {path: '/menu4', name: 'menu4',meta:{title:'碳标签'}, component:menu4},
                        {path: 'articleDetail', name: 'articleDetail', component:articleDetail }
                    ]
                },
                {
                    path: '/3060',
                    component: { render: h => h('router-view') },
                    name: '3060',
                    meta:{title:'双碳3060'},
                    redirect: '/3060/menu2_1',
                    children: [
                        {path: 'menu3060_1', name: 'menu3060_1',meta:{title:'国家各部委政策'}, component:menu3060_1},
                        {path: 'menu3060_2', name: 'menu3060_2',meta:{title:'国家部委碳足迹'}, component:menu3060_2},
                        {path: 'menu3060_3', name: 'menu3060_3',meta:{title:'各省市双碳政策'}, component:menu3060_3},
                        {path: 'articleDetail', name: 'articleDetail', component:articleDetail }
                    ]
                },
                {
                    path: '/resources/index',
                    name: 'resources',
                    meta:{title:'资源对接'},
                    component: resources,
                },
                {
                    path: '/aboutUs/index',
                    name: 'aboutUs',
                    meta:{title:'资源对接'},
                    component: aboutUs,
                },
                {
                    path: '/bigScreenMap',
                    name: 'bigScreenMap',
                    meta:{title:'综合大屏导航'},
                    component: bigScreenMap
                },
            ]
        },
        {
            path: '/wm/h5',
            component: H5Layout,
            redirect: '/wm/h5',
            title:'商业油烟智慧节能抽排系统 调查表',
            meta:{title:'商业油烟智慧节能抽排系统 调查表'},
            children: [
                {
                    meta:{title:'商业油烟智慧节能抽排系统 调查表'},
                    path: '/wm/h5',
                    name: 'H5Mobile',
                    component:  () => import('@/pages/H5Mobile/H5Mobile'),
                }
            ]
        },
    ]
})
